export const ROUTE_BASE = '/admin';

/** 個人中心 hub panel 枚舉（僅此三種；create/edit 勿塞進 panel） */
export const PERSONAL_CENTER_PANELS = Object.freeze(['profile', 'vouchers', 'claims']);

export const ROUTES = {
  home: ROUTE_BASE,
  login: '/login',
  /** 個人中心 hub（?panel=profile|vouchers|claims） */
  personalCenter: `${ROUTE_BASE}/personal-center`,
  personalCenterPanel: (panel) => (
    `${ROUTE_BASE}/personal-center?panel=${encodeURIComponent(panel)}`
  ),
  /** 修改資料（暱稱／改密 Tabs） */
  personalCenterEdit: `${ROUTE_BASE}/personal-center/edit`,
  personalCenterEditPassword: `${ROUTE_BASE}/personal-center/edit?tab=password`,
  /** 深鏈 path → hub ?panel=vouchers */
  personalCenterVouchers: `${ROUTE_BASE}/personal-center/vouchers`,
  personalCenterVouchersPanel: `${ROUTE_BASE}/personal-center?panel=vouchers`,
  personalCenterVoucherCreate: `${ROUTE_BASE}/personal-center/vouchers/create`,
  personalCenterVoucherEdit: (id) => (
    `${ROUTE_BASE}/personal-center/vouchers/${id}/edit`
  ),
  personalCenterVoucherDetail: (id) => (
    `${ROUTE_BASE}/personal-center/vouchers/${id}`
  ),
  /** 深鏈 path → hub ?panel=claims */
  personalCenterClaims: `${ROUTE_BASE}/personal-center/claims`,
  personalCenterClaimsPanel: `${ROUTE_BASE}/personal-center?panel=claims`,
  personalCenterClaimCreate: `${ROUTE_BASE}/personal-center/claims/create`,
  personalCenterClaimEdit: (id) => (
    `${ROUTE_BASE}/personal-center/claims/${id}/edit`
  ),
  personalCenterClaimDetail: (id) => (
    `${ROUTE_BASE}/personal-center/claims/${id}`
  ),
  /** 由請款單開關聯憑證（唯讀） */
  personalCenterClaimVoucherDetail: (id, voucherId) => (
    `${ROUTE_BASE}/personal-center/claims/${id}/vouchers/${voucherId}`
  ),
  /** 財務管理（會計審核）：請款單／憑證列表與詳情 */
  fmsMgmt: `${ROUTE_BASE}/fms-mgmt`,
  fmsPaymentRequest: `${ROUTE_BASE}/fms-mgmt/payment-requests`,
  fmsPaymentRequestDetail: (id) => `${ROUTE_BASE}/fms-mgmt/payment-requests/${id}`,
  fmsPaymentRequestVoucherDetail: (id, voucherId) => (
    `${ROUTE_BASE}/fms-mgmt/payment-requests/${id}/vouchers/${voucherId}`
  ),
  fmsVoucher: `${ROUTE_BASE}/fms-mgmt/vouchers`,
  fmsVoucherDetail: (id) => `${ROUTE_BASE}/fms-mgmt/vouchers/${id}`,
  /**
   * @deprecated 使用 personalCenter／personalCenterPanel
   * 別名指向新 path（舊 URL 仍靠 router Navigate redirect）
   */
  accountProfile: `${ROUTE_BASE}/personal-center?panel=profile`,
  /** @deprecated 使用 personalCenterEdit */
  accountEdit: `${ROUTE_BASE}/personal-center/edit`,
  /** @deprecated 使用 personalCenterEditPassword */
  accountEditPassword: `${ROUTE_BASE}/personal-center/edit?tab=password`,
  /** @deprecated 使用 personalCenterClaims */
  accountClaims: `${ROUTE_BASE}/personal-center/claims`,
  /** @deprecated 使用 personalCenterClaimsPanel */
  accountClaimsPanel: `${ROUTE_BASE}/personal-center?panel=claims`,
  /** @deprecated 使用 personalCenterVouchers */
  accountVouchers: `${ROUTE_BASE}/personal-center/vouchers`,
  /** @deprecated 使用 personalCenterVouchersPanel */
  accountVouchersPanel: `${ROUTE_BASE}/personal-center?panel=vouchers`,
  /** @deprecated 使用 personalCenterVoucherCreate */
  accountVoucherCreate: `${ROUTE_BASE}/personal-center/vouchers/create`,
  /** @deprecated 使用 personalCenterVoucherEdit */
  accountVoucherEdit: (id) => (
    `${ROUTE_BASE}/personal-center/vouchers/${id}/edit`
  ),
  /** @deprecated 使用 personalCenterClaimCreate */
  accountClaimCreate: `${ROUTE_BASE}/personal-center/claims/create`,
  /** @deprecated 使用 personalCenterClaimEdit */
  accountClaimEdit: (id) => (
    `${ROUTE_BASE}/personal-center/claims/${id}/edit`
  ),
  /** 系統設定 — RBAC 實驗薄頁 */
  systemSetting: `${ROUTE_BASE}/setting`,
  systemRoles: `${ROUTE_BASE}/setting/roles`,
  systemRoleCreate: `${ROUTE_BASE}/setting/roles/create`,
  systemRoleEdit: (id) => `${ROUTE_BASE}/setting/roles/${id}/edit`,
  systemUsers: `${ROUTE_BASE}/setting/users`,
  systemUserCreate: `${ROUTE_BASE}/setting/users/create`,
  systemUserEdit: (id) => `${ROUTE_BASE}/setting/users/${id}/edit`,
  systemUserAccess: `${ROUTE_BASE}/setting/user-access`,
  systemUserAccessFor: (userId) => (
    `${ROUTE_BASE}/setting/user-access?userId=${encodeURIComponent(userId)}`
  ),
  warehouse: `${ROUTE_BASE}/warehouse`,
  inventoryStock: `${ROUTE_BASE}/warehouse/inventory`,
  inventorySafetyCheck: `${ROUTE_BASE}/warehouse/safety-stock`,
  materialMgmt: `${ROUTE_BASE}/warehouse/material-mgmt`,
  documentMgmt: `${ROUTE_BASE}/warehouse/document-mgmt`,
  /** 開發工具（僅 dev；build 後路由與選單皆不存在） */
  devTools: `${ROUTE_BASE}/dev`,
  errorTest: `${ROUTE_BASE}/error-test`,
  layoutDemo: `${ROUTE_BASE}/layout-demo`,
  tableDemo: `${ROUTE_BASE}/table-demo`,
  dialogDemo: `${ROUTE_BASE}/dialog-demo`,
  stockReceipt: `${ROUTE_BASE}/warehouse/receipts/stock-receipt`,
  stockReceiptCreate: `${ROUTE_BASE}/warehouse/receipts/stock-receipt/create`,
  stockReceiptEdit: (id) => `${ROUTE_BASE}/warehouse/receipts/stock-receipt/${id}/edit`,
  stockReceiptRemark: (id) => `${ROUTE_BASE}/warehouse/receipts/stock-receipt/${id}/remark`,
  stockReceiptDetail: (id) => `${ROUTE_BASE}/warehouse/receipts/stock-receipt/${id}`,
  stockReceiptPreview: `${ROUTE_BASE}/dev/stock-receipt-preview`,
  /** @deprecated 使用 stockReceiptPreview */
  inboundPreview: `${ROUTE_BASE}/dev/stock-receipt-preview`,
  stockTransfer: `${ROUTE_BASE}/warehouse/receipts/stock-transfer`,
  stockTransferCreate: `${ROUTE_BASE}/warehouse/receipts/stock-transfer/create`,
  stockTransferEdit: (id) => `${ROUTE_BASE}/warehouse/receipts/stock-transfer/${id}/edit`,
  stockTransferRemark: (id) => `${ROUTE_BASE}/warehouse/receipts/stock-transfer/${id}/remark`,
  stockTransferDetail: (id) => `${ROUTE_BASE}/warehouse/receipts/stock-transfer/${id}`,
  stockIssue: `${ROUTE_BASE}/warehouse/receipts/stock-issue`,
  stockIssueCreate: `${ROUTE_BASE}/warehouse/receipts/stock-issue/create`,
  stockIssueEdit: (id) => `${ROUTE_BASE}/warehouse/receipts/stock-issue/${id}/edit`,
  stockIssueRemark: (id) => `${ROUTE_BASE}/warehouse/receipts/stock-issue/${id}/remark`,
  stockIssueDetail: (id) => `${ROUTE_BASE}/warehouse/receipts/stock-issue/${id}`,
  stockAdjustment: `${ROUTE_BASE}/warehouse/receipts/stock-adjustment`,
  stockAdjustmentCreate: `${ROUTE_BASE}/warehouse/receipts/stock-adjustment/create`,
  stockAdjustmentEdit: (id) => `${ROUTE_BASE}/warehouse/receipts/stock-adjustment/${id}/edit`,
  stockAdjustmentRemark: (id) => `${ROUTE_BASE}/warehouse/receipts/stock-adjustment/${id}/remark`,
  stockAdjustmentDetail: (id) => `${ROUTE_BASE}/warehouse/receipts/stock-adjustment/${id}`,
  stocktake: `${ROUTE_BASE}/warehouse/receipts/stocktake`,
  stocktakeCreate: `${ROUTE_BASE}/warehouse/receipts/stocktake/create`,
  stocktakeComparison: `${ROUTE_BASE}/warehouse/receipts/stocktake?tab=comparison`,
  stocktakeEdit: (id) => `${ROUTE_BASE}/warehouse/receipts/stocktake/${id}/edit`,
  stocktakeDetail: (id) => `${ROUTE_BASE}/warehouse/receipts/stocktake/${id}`,
  stockIssueCategory: `${ROUTE_BASE}/warehouse/receipts/stock-issue-category`,
  stockIssueCategoryCreate: `${ROUTE_BASE}/warehouse/receipts/stock-issue-category/create`,
  stockIssueCategoryEdit: (id) => `${ROUTE_BASE}/warehouse/receipts/stock-issue-category/${id}/edit`,
  production: `${ROUTE_BASE}/production`,
  bom: `${ROUTE_BASE}/production/bom-mgmt`,
  bomCreate: `${ROUTE_BASE}/production/bom-mgmt/create`,
  bomDetail: (id) => `${ROUTE_BASE}/production/bom-mgmt/${id}`,
  bomEdit: (id) => `${ROUTE_BASE}/production/bom-mgmt/${id}/edit`,
  bomCopy: (id) => `${ROUTE_BASE}/production/bom-mgmt/${id}/copy`,
  workOrder: `${ROUTE_BASE}/production/order-mgmt`,
  workOrderCreate: `${ROUTE_BASE}/production/order-mgmt/create`,
  workOrderDetail: (id) => `${ROUTE_BASE}/production/order-mgmt/${id}`,
  workOrderEdit: (id) => `${ROUTE_BASE}/production/order-mgmt/${id}/edit`,
  workOrderRemark: (id) => `${ROUTE_BASE}/production/order-mgmt/${id}/remark`,
  workOrderTransfer: `${ROUTE_BASE}/production/order-mgmt/transfer`,
  workOrderTransferCreate: `${ROUTE_BASE}/production/order-mgmt/transfer/create`,
  workOrderTransferDetail: (id) => `${ROUTE_BASE}/production/order-mgmt/transfer/${id}`,
  workOrderTransferEdit: (id) => `${ROUTE_BASE}/production/order-mgmt/transfer/${id}/edit`,
  workOrderTransferRemark: (id) => `${ROUTE_BASE}/production/order-mgmt/transfer/${id}/remark`,
  workOrderReturn: `${ROUTE_BASE}/production/order-mgmt/return`,
  workOrderReturnCreate: `${ROUTE_BASE}/production/order-mgmt/return/create`,
  workOrderReturnDetail: (id) => `${ROUTE_BASE}/production/order-mgmt/return/${id}`,
  workOrderReturnEdit: (id) => `${ROUTE_BASE}/production/order-mgmt/return/${id}/edit`,
  workOrderReturnRemark: (id) => `${ROUTE_BASE}/production/order-mgmt/return/${id}/remark`,
  workOrderInbound: (id) => (
    `${ROUTE_BASE}/production/order-mgmt/${id}?tab=stockReceipts`
  ),
  workOrderInboundCreate: (id) => (
    `${ROUTE_BASE}/production/order-mgmt/${id}/inbound/create`
  ),
  workOrderInboundEdit: (id, receiptId) => (
    `${ROUTE_BASE}/production/order-mgmt/${id}/inbound/${receiptId}/edit`
  ),
  workOrderOutbound: (id) => (
    `${ROUTE_BASE}/production/order-mgmt/${id}?tab=stockIssues`
  ),
  workOrderOutboundCreate: (id) => (
    `${ROUTE_BASE}/production/order-mgmt/${id}/outbound/create`
  ),
  workOrderOutboundEdit: (id, issueId) => (
    `${ROUTE_BASE}/production/order-mgmt/${id}/outbound/${issueId}/edit`
  ),
  workOrderAmendmentCreate: (id) => (
    `${ROUTE_BASE}/production/order-mgmt/${id}/amendment/create`
  ),
  workOrderAmendmentEdit: (id, amendmentId) => (
    `${ROUTE_BASE}/production/order-mgmt/${id}/amendment/${amendmentId}/edit`
  ),
  analysis: `${ROUTE_BASE}/production/analysis`,
  analysisOrders: `${ROUTE_BASE}/production/analysis?tab=orders`,
  analysisMaterials: `${ROUTE_BASE}/production/analysis?tab=materials`,
  processingFactory: `${ROUTE_BASE}/production/factory-mgmt`,
  processingFactoryCreate: `${ROUTE_BASE}/production/factory-mgmt/create`,
  processingFactoryEdit: (id) => `${ROUTE_BASE}/production/factory-mgmt/${id}/edit`,
  customer: `${ROUTE_BASE}/crm-mgmt/customer`,
  customerCreate: `${ROUTE_BASE}/crm-mgmt/customer/create`,
  customerEdit: (id) => `${ROUTE_BASE}/crm-mgmt/customer/${id}/edit`,
  customerDetail: (id) => `${ROUTE_BASE}/crm-mgmt/customer/${id}`,
  product: `${ROUTE_BASE}/crm-mgmt/product`,
  productCreate: `${ROUTE_BASE}/crm-mgmt/product/create`,
  productEdit: (id) => `${ROUTE_BASE}/crm-mgmt/product/${id}/edit`,
  productDetail: (id) => `${ROUTE_BASE}/crm-mgmt/product/${id}`,
  customerOrder: `${ROUTE_BASE}/crm-mgmt/customer-order`,
  customerOrderCreate: `${ROUTE_BASE}/crm-mgmt/customer-order/create`,
  customerOrderEdit: (id) => `${ROUTE_BASE}/crm-mgmt/customer-order/${id}/edit`,
  customerOrderDetail: (id) => `${ROUTE_BASE}/crm-mgmt/customer-order/${id}`,
  customerOrderRemark: (id) => `${ROUTE_BASE}/crm-mgmt/customer-order/${id}/remark`,
  customerOrderManufacturingMaterials: (id) => (
    `${ROUTE_BASE}/crm-mgmt/customer-order/${id}/manufacturing-materials`
  ),
  quotation: `${ROUTE_BASE}/crm-mgmt/quotation`,
  quotationCreate: `${ROUTE_BASE}/crm-mgmt/quotation/create`,
  quotationEdit: (id) => `${ROUTE_BASE}/crm-mgmt/quotation/${id}/edit`,
  quotationDetail: (id) => `${ROUTE_BASE}/crm-mgmt/quotation/${id}`,
  quotationRemark: (id) => `${ROUTE_BASE}/crm-mgmt/quotation/${id}/remark`,
  costEstimate: `${ROUTE_BASE}/crm-mgmt/cost-estimate`,
  costEstimateCreate: `${ROUTE_BASE}/crm-mgmt/cost-estimate/create`,
  costEstimateEdit: (id) => `${ROUTE_BASE}/crm-mgmt/cost-estimate/${id}/edit`,
  costEstimateDetail: (id) => `${ROUTE_BASE}/crm-mgmt/cost-estimate/${id}`,
  salesOrder: `${ROUTE_BASE}/crm-mgmt/sales-order`,
  salesOrderCreate: `${ROUTE_BASE}/crm-mgmt/sales-order/create`,
  salesOrderEdit: (id) => `${ROUTE_BASE}/crm-mgmt/sales-order/${id}/edit`,
  salesOrderDetail: (id) => `${ROUTE_BASE}/crm-mgmt/sales-order/${id}`,
  salesOrderRemark: (id) => `${ROUTE_BASE}/crm-mgmt/sales-order/${id}/remark`,
  salesOrderAllocate: (id) => `${ROUTE_BASE}/crm-mgmt/sales-order/${id}/allocate`,
  salesOrderSnSelect: (id) => `${ROUTE_BASE}/crm-mgmt/sales-order/${id}/sn-select`,
  snSalesWarranty: `${ROUTE_BASE}/crm-mgmt/sn-sales-warranties`,
  customerPortal: '/customer',
  /** 產品維修：報修單／維修品項／維修報告／簽收單／物料序號（SPA path `/product-repair`；API 仍 /aftersales） */
  repairRequest: `${ROUTE_BASE}/product-repair/repair-requests`,
  repairRequestCreate: `${ROUTE_BASE}/product-repair/repair-requests/create`,
  repairRequestEdit: (id) => `${ROUTE_BASE}/product-repair/repair-requests/${id}/edit`,
  repairRequestDetail: (id) => `${ROUTE_BASE}/product-repair/repair-requests/${id}`,
  repairItem: `${ROUTE_BASE}/product-repair/repair-items`,
  repairItemDetail: (id) => `${ROUTE_BASE}/product-repair/repair-items/${id}`,
  repairReport: `${ROUTE_BASE}/product-repair/repair-reports`,
  repairReportEdit: (id) => `${ROUTE_BASE}/product-repair/repair-reports/${id}/edit`,
  repairReportDetail: (id) => `${ROUTE_BASE}/product-repair/repair-reports/${id}`,
  signReceipt: `${ROUTE_BASE}/product-repair/sign-receipts`,
  signReceiptCreate: `${ROUTE_BASE}/product-repair/sign-receipts/create`,
  signReceiptEdit: (id) => `${ROUTE_BASE}/product-repair/sign-receipts/${id}/edit`,
  signReceiptDetail: (id) => `${ROUTE_BASE}/product-repair/sign-receipts/${id}`,
  snProductMapping: `${ROUTE_BASE}/product-repair/sn-product-mappings`,
  snProductMappingCreate: `${ROUTE_BASE}/product-repair/sn-product-mappings/create`,
  snProductMappingEdit: (id) => `${ROUTE_BASE}/product-repair/sn-product-mappings/${id}/edit`,
  snProductMappingDetail: (id) => `${ROUTE_BASE}/product-repair/sn-product-mappings/${id}`,
  srmMgmt: `${ROUTE_BASE}/srm-mgmt`,
  purchaseOrder: `${ROUTE_BASE}/srm-mgmt/material-purchase`,
  purchaseOrderCreate: `${ROUTE_BASE}/srm-mgmt/material-purchase/create`,
  purchaseOrderEdit: (id) => `${ROUTE_BASE}/srm-mgmt/material-purchase/${id}/edit`,
  purchaseOrderDetail: (id) => `${ROUTE_BASE}/srm-mgmt/material-purchase/${id}`,
  purchaseOrderAmendmentCreate: (id) => (
    `${ROUTE_BASE}/srm-mgmt/material-purchase/${id}/amendment/create`
  ),
  purchaseOrderAmendmentEdit: (id, amendmentId) => (
    `${ROUTE_BASE}/srm-mgmt/material-purchase/${id}/amendment/${amendmentId}/edit`
  ),
  purchaseOrderInboundCreate: (id) => (
    `${ROUTE_BASE}/srm-mgmt/material-purchase/${id}/inbound/create`
  ),
  purchaseOrderArrivalScheduleCreate: (id) => (
    `${ROUTE_BASE}/srm-mgmt/material-purchase/${id}/arrival-schedules/create`
  ),
  purchaseOrderArrivalScheduleEdit: (poId, scheduleId) => (
    `${ROUTE_BASE}/srm-mgmt/material-purchase/${poId}/arrival-schedules/${scheduleId}/edit`
  ),
  purchaseOrderArrivalInboundCreate: (poId, scheduleId) => (
    `${ROUTE_BASE}/srm-mgmt/material-purchase/${poId}/arrival-schedules/${scheduleId}/inbound/create`
  ),
  miscPurchaseOrder: `${ROUTE_BASE}/srm-mgmt/material-purchase/non-stock`,
  miscPurchaseOrderCreate: `${ROUTE_BASE}/srm-mgmt/material-purchase/non-stock/create`,
  miscPurchaseOrderEdit: (id) => (
    `${ROUTE_BASE}/srm-mgmt/material-purchase/non-stock/${id}/edit`
  ),
  miscPurchaseOrderDetail: (id) => (
    `${ROUTE_BASE}/srm-mgmt/material-purchase/non-stock/${id}`
  ),
  miscPurchaseOrderAmendmentCreate: (id) => (
    `${ROUTE_BASE}/srm-mgmt/material-purchase/non-stock/${id}/amendment/create`
  ),
  miscPurchaseOrderAmendmentEdit: (id, amendmentId) => (
    `${ROUTE_BASE}/srm-mgmt/material-purchase/non-stock/${id}/amendment/${amendmentId}/edit`
  ),
  supplier: `${ROUTE_BASE}/srm-mgmt/supplier`,
  supplierCreate: `${ROUTE_BASE}/srm-mgmt/supplier/create`,
  supplierEdit: (id) => `${ROUTE_BASE}/srm-mgmt/supplier/${id}/edit`,
  mtrStruct: `${ROUTE_BASE}/warehouse/material-mgmt/structure`,
  mtrStructMainCreate: `${ROUTE_BASE}/warehouse/material-mgmt/structure/main/create`,
  mtrStructMainEdit: (id) => `${ROUTE_BASE}/warehouse/material-mgmt/structure/main/${id}/edit`,
  mtrStructSubCreate: `${ROUTE_BASE}/warehouse/material-mgmt/structure/sub/create`,
  mtrStructSubEdit: (id) => `${ROUTE_BASE}/warehouse/material-mgmt/structure/sub/${id}/edit`,
  mtrSpec: `${ROUTE_BASE}/warehouse/material-mgmt/spec`,
  mtrSpecCreate: `${ROUTE_BASE}/warehouse/material-mgmt/spec/create`,
  mtrSpecEdit: (id) => `${ROUTE_BASE}/warehouse/material-mgmt/spec/${id}/edit`,
  manufacturer: `${ROUTE_BASE}/warehouse/material-mgmt/manufacturer`,
  manufacturerCreate: `${ROUTE_BASE}/warehouse/material-mgmt/manufacturer/create`,
  manufacturerEdit: (id) => `${ROUTE_BASE}/warehouse/material-mgmt/manufacturer/${id}/edit`,
  materialSn: `${ROUTE_BASE}/warehouse/material-mgmt/material-sn`,
  inspectionKind: `${ROUTE_BASE}/warehouse/material-mgmt/inspection-kinds`,
  inspectionKindCreate: `${ROUTE_BASE}/warehouse/material-mgmt/inspection-kinds/create`,
  inspectionKindDetail: (id) => `${ROUTE_BASE}/warehouse/material-mgmt/inspection-kinds/${id}`,
  inspectionKindEdit: (id) => `${ROUTE_BASE}/warehouse/material-mgmt/inspection-kinds/${id}/edit`,
  inspectionKindRevision: (id, revisionNo) => (
    `${ROUTE_BASE}/warehouse/material-mgmt/inspection-kinds/${id}/revisions/${revisionNo}`
  ),
  mtrTemplate: `${ROUTE_BASE}/warehouse/material-mgmt/template`,
  mtrTemplateCreate: `${ROUTE_BASE}/warehouse/material-mgmt/template/create`,
  mtrTemplateEdit: (id) => `${ROUTE_BASE}/warehouse/material-mgmt/template/${id}/edit`,
  mtr: `${ROUTE_BASE}/warehouse/material-mgmt/material`,
  mtrCreate: `${ROUTE_BASE}/warehouse/material-mgmt/material/create`,
  mtrDetail: (id) => `${ROUTE_BASE}/warehouse/material-mgmt/material/${id}`,
  mtrEdit: (id) => `${ROUTE_BASE}/warehouse/material-mgmt/material/${id}/edit`,
  storePlaceMgmt: `${ROUTE_BASE}/warehouse/store-place-mgmt`,
  storePlaceWarehouse: `${ROUTE_BASE}/warehouse/store-place-mgmt/warehouse`,
  storePlaceWarehouseCreate: `${ROUTE_BASE}/warehouse/store-place-mgmt/warehouse/create`,
  storePlaceWarehouseEdit: (id) => `${ROUTE_BASE}/warehouse/store-place-mgmt/warehouse/${id}/edit`,
  storePlaceLocation: `${ROUTE_BASE}/warehouse/store-place-mgmt/location`,
  storePlaceLocationCreate: `${ROUTE_BASE}/warehouse/store-place-mgmt/location/create`,
  storePlaceLocationEdit: (id) => `${ROUTE_BASE}/warehouse/store-place-mgmt/location/${id}/edit`,
};
